import { render } from "./ClaimForm.vue?vue&type=template&id=10ea0f09"
import script from "./ClaimForm.vue?vue&type=script&lang=js"
export * from "./ClaimForm.vue?vue&type=script&lang=js"

import "./ClaimForm.vue?vue&type=style&index=0&id=10ea0f09&lang=scss"
script.render = render

export default script